<template>
  <el-container style="height: 100%">
      <el-main style="height: 100%">
          <iframe src="http://mj.shhtys.cn" style="width: 100%;height: 100%;display: block; overflow: hidden; border: none;" frameborder="no"  allowtransparency="yes"></iframe>
      </el-main>
      <el-footer>
        <div style="text-align: center">备案号：沪ICP备2025156470号;上海市青浦区公园路99号舜浦大厦2层</div>
      </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue